import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

const parseProjectRefFromSupabaseUrl = (url: string): string | null => {
  try {
    const hostname = new URL(url).hostname;
    return hostname.split('.')[0] || null;
  } catch {
    return null;
  }
};

const parseProjectRefFromAnonKey = (anonKey: string): string | null => {
  try {
    const payload = anonKey.split('.')[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(normalized));
    return typeof decoded?.ref === 'string' ? decoded.ref : null;
  } catch {
    return null;
  }
};

const urlProjectRef = supabaseUrl ? parseProjectRefFromSupabaseUrl(supabaseUrl) : null;
const keyProjectRef = supabaseAnonKey ? parseProjectRefFromAnonKey(supabaseAnonKey) : null;

let resolvedSupabaseUrl = supabaseUrl;
if (urlProjectRef && keyProjectRef && urlProjectRef !== keyProjectRef) {
  // If env values are mismatched, use the key's project ref to avoid auth fetch failures.
  resolvedSupabaseUrl = `https://${keyProjectRef}.supabase.co`;
  console.warn(
    `Supabase URL/key mismatch detected. Using ${resolvedSupabaseUrl}. Update VITE_SUPABASE_URL to match your anon key project ref.`
  );
}

if (!resolvedSupabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase credentials not found. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file. Running in demo mode.'
  );
}

export const supabase = createClient(
  resolvedSupabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
  }
);

export const isSupabaseConfigured = Boolean(resolvedSupabaseUrl && supabaseAnonKey);
